<template>
    <input class="ap-input-text" type="text" v-bind="$attrs" :readonly="readonly" @input="editText($event.target.value)" @change="editText($event.target.value)" :value="modelValue"  ref="input"  />
</template>

<script>
    import { ref, nextTick, onMounted } from 'vue'
    export default {
    name: 'ApInput',
        inheritAttrs: false,
        props: {
            readonly: Boolean,
            modelValue: String
        },
        emits: ['update:modelValue'],
        setup(props, { emit }) {
            const input = ref(null)

            onMounted(() => {
                nextTick(() => input.value?.focus())
            })

            const editText = (event) => {
                if (!props.readonly)
                    emit('update:modelValue', event)
            }

            return { editText }
        }
    }
</script>

<style lang="scss">
    @import '~styles/colors';

    input[type='text'].ap-input-text {
        background: $white;
        width: 100%;
        border-radius: 3px;
        height: 36px;
        line-height: 26px;
        border: 1px solid $input-border-color;
        padding: 0px 5px;
        color: $main-font-color;
        opacity: 1.0;

        &[readonly] {
            background-color: $input-readonly-bg-color;
            @include main-font-opacity(0.7);
        }
    }
</style>